import React, { memo } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { Warning } from '@phosphor-icons/react'
import {
  nodeCardClass, nodeChipClass, nodeHandleClass, nodeIcon, nodeTextClass, TONE_STYLES,
} from '../../nodeCatalog'
import { normalizeAutoReply, summarizeAutoReply, validateAutoReply } from '../../autoReplyConfig'

const TYPE = 'autoReply'
const Icon = nodeIcon(TYPE)

const AutoReplyNode: React.FC<NodeProps> = ({ data, selected }) => {
  const cfg = normalizeAutoReply(data.auto_reply_config)
  const summary = summarizeAutoReply(cfg)
  const problems = validateAutoReply(cfg)

  return (
    <div className={nodeCardClass(TYPE, selected)}>
      {/* Terminal node: both branches live inside it, so there is no source handle. */}
      <Handle type="target" position={Position.Top} className={nodeHandleClass(TYPE)} />
      <div className="flex items-center gap-2">
        <div className={nodeChipClass(TYPE)}>
          <Icon className={`w-4 h-4 ${nodeTextClass(TYPE)}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-[10px] font-emphasis uppercase tracking-wider ${nodeTextClass(TYPE)}`}>Reply handler</p>
          <p className="text-sm font-medium text-foreground truncate">{data.label || 'Auto Reply'}</p>
        </div>
        {problems.length > 0 && (
          <span title={problems[0]} aria-label={problems[0]}>
            <Warning className="w-4 h-4 text-amber-500" weight="fill" />
          </span>
        )}
      </div>
      <div className="mt-2 space-y-1">
        <div className="flex items-center gap-2">
          <span className={`shrink-0 rounded-full border px-1.5 text-[10px] font-medium ${TONE_STYLES.time.chip} ${TONE_STYLES.time.text}`}>
            No reply
          </span>
          <span className="text-xs text-muted-foreground truncate">{summary.noReply}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className={`shrink-0 rounded-full border px-1.5 text-[10px] font-medium ${TONE_STYLES.success.chip} ${TONE_STYLES.success.text}`}>
            Reply
          </span>
          <span className="text-xs text-muted-foreground truncate">{summary.reply}</span>
        </div>
      </div>
    </div>
  )
}

export default memo(AutoReplyNode)
